import { twMerge } from 'tailwind-merge';

import type { DivProps } from '@/types';

interface ProgressProps extends DivProps {
  value?: number;
  max?: number;
  progressStyle?: React.CSSProperties;
}

const Progress = ({ ref, className, value = 0, max = 100, progressStyle, ...props }: ProgressProps) => {
  const percentage = Math.min(Math.max((value / max) * 100, 0), 100);

  return (
    <div
      ref={ref}
      className={twMerge('relative h-2 w-full overflow-hidden rounded-full bg-gray-200 dark:bg-gray-700', className)}
      {...props}
    >
      <div
        className="bg-primary h-full w-full flex-1 transition-all duration-300 ease-in-out"
        style={{
          ...(progressStyle || {}),
          transform: `translateX(-${100 - percentage}%)`,
        }}
      />
    </div>
  );
};

export { Progress };
